import { render, staticRenderFns } from "./StoreReviews.vue?vue&type=template&id=09cdb98c&scoped=true&"
import script from "./StoreReviews.vue?vue&type=script&lang=js&"
export * from "./StoreReviews.vue?vue&type=script&lang=js&"
import style0 from "./StoreReviews.vue?vue&type=style&index=0&id=09cdb98c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cdb98c",
  null
  
)

export default component.exports